export default __webpack_public_path__ + "static/media/tired.aa6500e5.png";